import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Button } from 'components';
import { eclipseDriveLogoIcon } from 'assets/images';
import { PathName } from 'appConstants';
import { useSelector } from 'react-redux';
import { profileSelectors } from 'store/profile/selectors';
import styles from './styles.module.scss';

const statKeys = ['product', 'income', 'final', 'ambassador'] as const;

interface IHeroSectionProps {
  isAuthenticated: boolean;
}

export const HeroSection = ({ isAuthenticated }: IHeroSectionProps) => {
  const { t } = useTranslation('eclipseDrive');
  const navigate = useNavigate();
  const { referralCode } = useSelector(profileSelectors.getState);

  const renderStatText = (text: string) => {
    const parts = text.split(':');
    if (parts.length === 2) {
      return (
        <>
          <span className={styles.stat_label}>
            {parts[0].trim()}
            :
          </span>
          <br />
          {parts[1].trim()}
        </>
      );
    }
    return text;
  };

  return (
    <div className={styles.hero_section}>
      <div className={styles.hero_content}>
        <img
          src={eclipseDriveLogoIcon}
          alt={t('hero.logoAlt')}
          className={styles.logo}
        />
        
        <h1 className={styles.hero_title}>
          <span className={styles.hero_title_bold}>{t('hero.titleBold')}</span>
          {t('hero.titleRegular')}
        </h1>
        
        <p className={styles.hero_subtitle}>
          {t('hero.subtitle')}
        </p>
        
        <div className={styles.stats_pills}>
          {statKeys.map((key) => (
            <div
              key={key}
              className={styles.stat_pill}
            >
              <span className={styles.stat_text}>
                {renderStatText(t(`hero.stats.${key}`))}
              </span>
            </div>
          ))}
        </div>
        
        {!isAuthenticated && (
          <div className={styles.cta_wrapper}>
            <Button 
              type="button"
              className={styles.cta_button} 
              onClick={() => navigate(`${PathName.Registration}/?ref=${referralCode}`)}
            >
              {t('hero.cta')}
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};
